import React from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router/dom"
import createAppRouter from "src/router/create-app-router"

if (process.env.NODE_ENV === "production") {
  const sha = process.env.REACT_APP_SHA
  // oxlint-disable-next-line no-console
  console.log(`App Version ${process.env.REACT_APP_VERSION}, ${sha}`)
}
const root = createRoot(document.getElementById("root") as HTMLElement)
{
  let ui: React.ReactNode = <RouterProvider router={createAppRouter()} />

  // global suspense that renders nothing for the fallback to avoid throwing when someone forgets to put a suspense
  ui = <React.Suspense fallback={null}>{ui}</React.Suspense>

  // StrictMode should be at the top
  ui = <React.StrictMode>{ui}</React.StrictMode>

  root.render(ui)
}
